import WarehouseImage from '../assets/images/3d-icons/warehouse.png';
import LeafImage from '../assets/images/3d-icons/leaf.png';
import SpotImage from '../assets/images/3d-icons/spot.png';

export const TAG_LEVEL_ACCENT_COLORS: ('accentPrimary' | 'accentSecondary')[] = [
  'accentPrimary',
  'accentSecondary',
];
export const TAG_LEVEL_TONAL_COLORS: ('tonalAccentPrimary' | 'tonalAccentSecondary')[] = [
  'tonalAccentPrimary',
  'tonalAccentSecondary',
];
export const TAG_LEVEL_CONTAINER_COLORS: ('accentPrimaryContainer' | 'accentSecondaryContainer')[] = [
  'accentPrimaryContainer',
  'accentSecondaryContainer',
];

export enum CompanyCategoryEnum {
  WHOLESALER = 'WHOLESALER',
  LOCAL_PRODUCER = 'LOCAL_PRODUCER',
  NON_LOCAL_PRODUCER = 'NON_LOCAL_PRODUCER'
}

export const CompanyCategoryIconMap: {[key in CompanyCategoryEnum]: string} = {
  WHOLESALER: WarehouseImage,
  LOCAL_PRODUCER: SpotImage,
  NON_LOCAL_PRODUCER: LeafImage,
};
